import React, { FC } from 'react';
import { isMobile } from 'react-device-detect';
import { FilterDesktop } from './FilterDesktop';
import { FilterMobile } from './FilterMobile';

export const Filter: FC = () => (isMobile ? <FilterMobile /> : <FilterDesktop />);
